// extracted by mini-css-extract-plugin
module.exports = {"app":"DefaultLayout_app__HPlC3","loading":"DefaultLayout_loading__39k64","imageWrapper":"DefaultLayout_imageWrapper__2z157"};